export const menuItems = [
  {
    text: 'カレンダー',
    icon: '/images/icons/ic-calendar.svg',
    iconActive: '/images/icons/ic-calendar-active.svg',
    href: '/calendar/index',
    sub: [],
  },
  {
    text: '来院',
    icon: '/images/icons/ic-hospital.svg',
    iconActive: '/images/icons/ic-hospital-active.svg',
    href: '/reception',
    sub: [],
  },
  {
    text: '患者',
    icon: '/images/icons/ic-patient.svg',
    iconActive: '/images/icons/ic-patient-active.svg',
    href: '/patients',
    subLink: ['/patient/view', '/patient/schema'],
    sub: [],
  },
  {
    text: '予約',
    icon: '/images/icons/ic-reservation-new.svg',
    iconActive: '/images/icons/ic-reservation-new-active.svg',
    href: '/reservations',
    sub: [],
  },
  {
    text: '会計',
    icon: '/images/icons/ic-total.svg',
    iconActive: '/images/icons/ic-total-active.svg',
    href: '#',
    subLink: ['/payments', '/quotations'],
    sub: [
      {
        text: '未納/収納',
        icon: '/images/icons/ic-unpaid.svg',
        iconActive: '/images/icons/ic-unpaid-active.svg',
        href: '/payments',
        sub: [],
      },
      {
        text: '見積',
        icon: '/images/icons/ic-quote.svg',
        iconActive: '/images/icons/ic-quote-active.svg',
        href: '/quotations',
        sub: [],
      },
    ],
  },
  {
    text: 'タスク',
    icon: '/images/icons/ic-task.svg',
    iconActive: '/images/icons/ic-task-active.svg',
    href: '#',
    subLink: ['/patient/task', '/patient/task-edit', '/surgery-calendar', '/surgery-schedule'],
    sub: [
      {
        text: 'タスクー覧',
        icon: '/images/icons/ic-task.svg',
        iconActive: '/images/icons/ic-task-active.svg',
        href: '/patient/task',
        sub: [],
      },
      {
        text: '手術カレンダー',
        icon: '/images/icons/ic-calendar.svg',
        iconActive: '/images/icons/ic-calendar-active.svg',
        href: '/surgery-calendar',
        sub: [],
      }
    ],
  },
  {
    text: '在庫管理',
    icon: '/images/icons/ic-stock.svg',
    iconActive: '/images/icons/ic-stock-active.svg',
    href: '#',
    subLink: ['/stocks', '/stocks/surgical-material'],
    sub: [
      {
        text: '物販',
        icon: '/images/icons/ic-merchandise.svg',
        iconActive: '/images/icons/ic-merchandise-active.svg',
        href: '/stocks',
        sub: [],
      },
      {
        text: '手術材料',
        icon: '/images/icons/ic-surgical-material.svg',
        iconActive: '/images/icons/ic-surgical-material-active.svg',
        href: '/stocks/surgical-material',
        sub: [],
      },
    ],
  },
  {
    text: '勤務表',
    icon: '/images/icons/ic-work-list.svg',
    iconActive: '/images/icons/ic-work-list-active.svg',
    href: '/calendar/month',
    sub: [],
  },
  {
    text: '分析',
    icon: '/images/icons/ic-analysis.svg',
    iconActive: '/images/icons/ic-analysis-active.svg',
    href: '#',
    subLink: ['/report/payment', '/report/sales', '/report/download'],
    sub: [
      {
        text: '売上',
        icon: '/images/icons/ic-amount.svg',
        iconActive: '/images/icons/ic-amount-active.svg',
        href: '/report/payment',
        sub: [],
      },
      {
        text: '施術別',
        icon: '/images/icons/ic-by-treatment.svg',
        iconActive: '/images/icons/ic-by-treatment-active.svg',
        href: '/report/sales',
        sub: [],
      },
      {
        text: 'CSV出力',
        icon: '/images/icons/ic-export-csv.svg',
        iconActive: '/images/icons/ic-export-csv-active.svg',
        href: '/report/download',
        sub: [],
      },
    ],
  },
  {
    text: '在庫管理',
    icon: '/images/icons/ic-user.svg',
    iconActive: '/images/icons/ic-user-active.svg',
    href: '/inventory',
    sub: [],
  },
  {
    text: 'メールログ',
    icon: '/images/icons/ic-mail-log.svg',
    iconActive: '/images/icons/ic-mail-log-active.svg',
    href: '/master/email-log',
    sub: [],
  },
  {
    text: 'マスタ',
    icon: '/images/icons/ic-master.svg',
    iconActive: '/images/icons/ic-master-active.svg',
    href: '#',
    subLink: ['/master/surgery', '/master/product', '/master/product-op', '/master/part', '/master/doctor-config'],
    sub: [
      {
        text: '施術',
        icon: '/images/icons/ic-by-treatment.svg',
        iconActive: '/images/icons/ic-by-treatment-active.svg',
        href: '/master/surgery',
        sub: [],
      },
      {
        text: '物販',
        icon: '/images/icons/ic-merchandise.svg',
        iconActive: '/images/icons/ic-merchandise-active.svg',
        href: '/master/product',
        sub: [],
      },
      {
        text: '手術材料',
        icon: '/images/icons/ic-surgical-material.svg',
        iconActive: '/images/icons/ic-surgical-material-active.svg',
        href: '/master/product-op',
        sub: [],
      },
      {
        text: '希望施術',
        icon: '/images/icons/ic-desired-treatment.svg',
        iconActive: '/images/icons/ic-desired-treatment-active.svg',
        href: '/master/part',
        sub: [],
      },
      {
        text: '医師価格',
        icon: '/images/icons/ic-doctor-price.svg',
        iconActive: '/images/icons/ic-doctor-price-active.svg',
        href: '/master/doctor-config',
        sub: [],
      },
    ],
  },
  {
    text: 'テンプレート',
    icon: '/images/icons/ic-template.svg',
    iconActive: '/images/icons/ic-template-active.svg',
    href: '#',
    subLink: ['/master/email', '/master/email-view', '/master/email-edit', '/template/quotation', '/template/document', '/template/shema'],
    sub: [
      {
        text: 'メール',
        icon: '/images/icons/ic-mail.svg',
        iconActive: '/images/icons/ic-mail-active.svg',
        href: '/master/email',
        sub: [],
      },
      {
        text: '見積',
        icon: '/images/icons/ic-quote.svg',
        iconActive: '/images/icons/ic-quote-active.svg',
        href: '/template/quotation',
        sub: [],
      },
      {
        text: '書類',
        icon: '/images/icons/ic-document.svg',
        iconActive: '/images/icons/ic-document-active.svg',
        href: '/template/document',
        sub: [],
      },
      {
        text: 'シェーマー',
        icon: '/images/icons/ic-schema.svg',
        iconActive: '/images/icons/ic-schema-active.svg',
        href: '/template/shema',
        sub: [],
      },
    ],
  },
  {
    text: '設定',
    icon: '/images/icons/ic-setting.svg',
    iconActive: '/images/icons/ic-setting-active.svg',
    href: '#',
    subLink: ['/user/index', '/user/view', '/user/edit', '/master/reserve-color', '/master/patient-icon', '/master/time', '/setting/site', '/patient/integration', '/patient/questions'],
    sub: [
      {
        text: 'ユーザー',
        icon: '/images/icons/ic-user.svg',
        iconActive: '/images/icons/ic-user-active.svg',
        href: '/user/index',
        sub: [],
      },
      {
        text: 'カレンダーカラー',
        icon: '/images/icons/ic-calendar.svg',
        iconActive: '/images/icons/ic-calendar-active.svg',
        href: '/master/reserve-color',
        sub: [],
      },
      {
        text: '患者アイコン',
        icon: '/images/icons/ic-patient.svg',
        iconActive: '/images/icons/ic-patient-active.svg',
        href: '/master/patient-icon',
        sub: [],
      },
      {
        text: '患者予約機能',
        icon: '/images/icons/ic-patient-reservation-func.svg',
        iconActive: '/images/icons/ic-patient-reservation-func-active.svg',
        href: '/master/time',
        sub: [],
      },
      {
        text: '患者統合',
        icon: '/images/icons/ic-patient.svg',
        iconActive: '/images/icons/ic-patient-active.svg',
        href: '/patient/integration',
        sub: [],
      },
      {
        text: '問診票',
        icon: '/images/icons/ic-counseling.svg',
        iconActive: '/images/icons/ic-counseling-active.svg',
        href: '/patient/questions',
        sub: [],
      },
    ],
  },
  {
    text: '一括アップロード',
    icon: '/images/icons/ic_bulk_upload.svg',
    iconActive: '/images/icons/ic_bulk_upload-active.svg',
    href: '/bulkupload',
    sub: [],
  },
  {
    text: 'カウンセリング一覧',
    icon: '/images/icons/ic-counseling.svg',
    iconActive: '/images/icons/ic-counseling-active.svg',
    href: '/counseling',
    sub: [],
  }
];
